var map = {
	"./ada-lovelace.png": 3384,
	"./albert-einstein.png": 8422,
	"./avatar.svg": 8631,
	"./batlamyus.png": 6712,
	"./chien-shiung-wu.png": 7453,
	"./emmanuelle-charpentier.png": 9519,
	"./herodot.png": 1135,
	"./immanuel-kant.png": 1705,
	"./isaac-newton.png": 1795,
	"./jennifer-doudna.png": 1685,
	"./katherine-johnson.png": 7301,
	"./lise-meitner.png": 6158,
	"./marie-curie.png": 843,
	"./niels-bohr.png": 5639,
	"./platon.png": 2004,
	"./rene-descartes.png": 257,
	"./richard-feynman.png": 7362,
	"./robert-oppenheimer.png": 5455,
	"./rosalind-franklin.png": 7188,
	"./socrates.png": 4174,
	"./thales.png": 3379,
	"./vera-rubin.png": 4897,
	"./william-shakespeare.png": 2020
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9750;